import classNames from 'classnames/bind';
import Button from 'mcs-toolkit/components/Button';
import React from 'react';
import { EventHelper } from 'utils/EventHelper';

import { Input, InputProps } from 'reactComponents/Input/Input';

import styles from './InputNumber.css';

const css = classNames.bind(styles);

const minusSign = '–';
const plusSign = '+';

export type InputNumberProps = InputProps & {
    className?: string;
    dataTest?: string;
    inputClassName?: string;
    min?: any;
    max?: any;
    value?: any;
    width?: number | string;
    step?: number;
    withoutButtons?: boolean;
};

export class InputNumber extends React.PureComponent<InputNumberProps> {
    _inputNode?: HTMLInputElement | null;

    _getStep = () => this.props.step || 1;

    _handleSubtract = () => {
        const value = Number(this._inputNode?.value || 0);
        this._setValue(value - this._getStep());
    };

    _handleAdd = () => {
        const value = Number(this._inputNode?.value || 0);
        this._setValue(value + this._getStep());
    };

    _setValue = (value) => {
        if (!Number.isNaN(+value)) {
            EventHelper.emitInputEvent(this._inputNode, value);
        }
    };

    _handleButtonBlur = (event) => {
        if (this.props.onBlur) {
            // @ts-ignore
            this.props.onBlur(event, this.props);
        }
    };

    renderButton(sign) {
        const isMinus = sign === minusSign;
        const { min, max, value, dataTest } = this.props;
        const isDisabled =
            this.props.disabled ||
            (isMinus
                ? Number.isFinite(min) && value <= min
                : Number.isFinite(max) && value >= max);

        return (
            <Button
                data-test={
                    isMinus
                        ? `button-${dataTest}-decrement`
                        : `button-${dataTest}-increment`
                }
                disabled={isDisabled}
                onClick={isMinus ? this._handleSubtract : this._handleAdd}
                type="button"
                basic
                className={css('button')}
                onBlur={this._handleButtonBlur}
            >
                {sign}
            </Button>
        );
    }

    render() {
        const {
            className,
            inputClassName,
            min,
            max,
            value,
            width,
            onChange,
            withoutButtons,
            ...otherInputProps
        } = this.props;

        return (
            <div
                className={css('root', className)}
                style={
                    width == null
                        ? undefined
                        : {
                              width,
                          }
                }
            >
                {!withoutButtons && this.renderButton(minusSign)}
                <Input
                    className={css('input', inputClassName)}
                    min={min}
                    max={max}
                    value={String(value)}
                    inputRef={(node) => {
                        this._inputNode = node;
                    }}
                    onChange={(event, data: any) => {
                        if (
                            data.hasOwnProperty('value') &&
                            !data.value.includes('.') // дробные значения не кастим к number, потому что обрежется дробная часть, если пользователь захочет ввести 1,01
                        ) {
                            data.value = Number(data.value);
                        }
                        onChange && onChange(event, data);
                    }}
                    {...otherInputProps}
                />
                {!withoutButtons && this.renderButton(plusSign)}
            </div>
        );
    }
}
